const SelectOption = ({ text, ...props }) => <option {...props}>{text}</option>;

export default SelectOption;
